import Video from '../components/video'

window.theme = window.theme || {}

const selectors = {
  videoSection: '[data-section-type="video-hw"]',
  videoContainer: '.video-hw__video',
}

const VideoHalfWidth = (() => {

  function init() {
    if ((document.querySelector(selectors.videoSection) == null) || (document.querySelector(selectors.videoSection) == undefined)) {
      return
    }
    Video(selectors).init()
  }

  return {
    init,
  }
})()

export default VideoHalfWidth